import React from 'react';
import { SaveIcon } from 'lucide-react';
const Settings: React.FC = () => {
  return <div className="bg-gray-800 rounded-lg overflow-hidden" data-id="element-189">
      <div className="p-4 border-b border-gray-700" data-id="element-190">
        <h2 className="text-xl font-semibold" data-id="element-191">API Connections</h2>
      </div>
      <div className="p-4 space-y-6" data-id="element-192">
        <div className="space-y-4" data-id="element-193">
          <h3 className="text-lg font-medium" data-id="element-194">Bluesky Jetstream</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-195">
            <div data-id="element-196">
              <label className="block text-sm text-gray-400 mb-1" data-id="element-197">
                API Key
              </label>
              <input type="password" className="w-full bg-gray-700 border border-gray-600 rounded p-2 text-sm" value="••••••••••••••••••••••" data-id="element-198" />
            </div>
            <div data-id="element-199">
              <label className="block text-sm text-gray-400 mb-1" data-id="element-200">Handle</label>
              <input type="text" className="w-full bg-gray-700 border border-gray-600 rounded p-2 text-sm" value="@company.bsky.social" data-id="element-201" />
            </div>
          </div>
          <div className="flex items-center" data-id="element-202">
            <div className="w-3 h-3 rounded-full bg-green-400 mr-2" data-id="element-203"></div>
            <span className="text-sm text-gray-300" data-id="element-204">Connected</span>
          </div>
        </div>
        <div className="space-y-4" data-id="element-205">
          <h3 className="text-lg font-medium" data-id="element-206">Vector Database</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-207">
            <div data-id="element-208">
              <label className="block text-sm text-gray-400 mb-1" data-id="element-209">
                Provider
              </label>
              <select className="w-full bg-gray-700 border border-gray-600 rounded p-2 text-sm" data-id="element-210">
                <option data-id="element-211">Pinecone</option>
                <option data-id="element-212">Weaviate</option>
                <option data-id="element-213">Milvus</option>
              </select>
            </div>
            <div data-id="element-214">
              <label className="block text-sm text-gray-400 mb-1" data-id="element-215">
                API Key
              </label>
              <input type="password" className="w-full bg-gray-700 border border-gray-600 rounded p-2 text-sm" value="••••••••••••••••••••••" data-id="element-216" />
            </div>
          </div>
          <div data-id="element-217">
            <label className="block text-sm text-gray-400 mb-1" data-id="element-218">
              Index Name
            </label>
            <input type="text" className="w-full bg-gray-700 border border-gray-600 rounded p-2 text-sm" value="social-intent-matches" data-id="element-219" />
          </div>
          <div className="flex items-center" data-id="element-220">
            <div className="w-3 h-3 rounded-full bg-green-400 mr-2" data-id="element-221"></div>
            <span className="text-sm text-gray-300" data-id="element-222">Connected</span>
          </div>
        </div>
        <div className="space-y-4" data-id="element-223">
          <h3 className="text-lg font-medium" data-id="element-224">AI Sales Agent</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-225">
            <div data-id="element-226">
              <label className="block text-sm text-gray-400 mb-1" data-id="element-227">
                Provider
              </label>
              <select className="w-full bg-gray-700 border border-gray-600 rounded p-2 text-sm" data-id="element-228">
                <option data-id="element-229">OpenAI</option>
                <option data-id="element-230">Anthropic</option>
                <option data-id="element-231">Custom Endpoint</option>
              </select>
            </div>
            <div data-id="element-232">
              <label className="block text-sm text-gray-400 mb-1" data-id="element-233">
                API Key
              </label>
              <input type="password" className="w-full bg-gray-700 border border-gray-600 rounded p-2 text-sm" value="••••••••••••••••••••••" data-id="element-234" />
            </div>
          </div>
          <div data-id="element-235">
            <label className="block text-sm text-gray-400 mb-1" data-id="element-236">Model</label>
            <select className="w-full bg-gray-700 border border-gray-600 rounded p-2 text-sm" data-id="element-237">
              <option data-id="element-238">gpt-4o</option>
              <option data-id="element-239">gpt-4-turbo</option>
              <option data-id="element-240">claude-3-opus</option>
            </select>
          </div>
          <div className="flex items-center" data-id="element-241">
            <div className="w-3 h-3 rounded-full bg-green-400 mr-2" data-id="element-242"></div>
            <span className="text-sm text-gray-300" data-id="element-243">Connected</span>
          </div>
        </div>
        <div className="pt-4 border-t border-gray-700 flex justify-end" data-id="element-244">
          <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded flex items-center gap-2" data-id="element-245">
            <SaveIcon className="w-4 h-4" data-id="element-246" />
            Save Settings
          </button>
        </div>
      </div>
    </div>;
};
export default Settings;